import React from 'react';

// Topic pill bar + scrollable HTML content for the active help section.
export default function HelpContent({ section, activeTopic, onTopicChange }) {
  const current = section.topics.find((t) => t.id === activeTopic) || section.topics[0];

  return (
    <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
      <div className="border-bottom p-3">
        <div className="d-flex flex-wrap gap-2">
          {section.topics.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`btn btn-sm rounded-pill ${activeTopic === t.id ? 'btn-primary' : 'btn-light border'}`}
              aria-pressed={activeTopic === t.id}
              onClick={() => onTopicChange(t.id)}
            >
              {t.title}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-grow-1 overflow-auto p-4 help-content-body">
        {current ? (
          <>
            <h3 className="h5 fw-bold mb-3">{current.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: current.body }} />
          </>
        ) : (
          <p className="text-muted">Select a topic to read.</p>
        )}
      </div>
    </div>
  );
}
